/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */
import * as React from "react";
import { assertSlots } from "@fluentui/react-components";
import { MenuItemShim } from "../../AppContextualMenu/next/AppMenuItem/MenuItemShim";
import type { AppFlexMenuSlots, AppFlexMenuState } from "./AppFlexMenu.types";

export const renderAppFlexMenu: React.FC<AppFlexMenuState> = (
  state: AppFlexMenuState
) => {
  assertSlots<AppFlexMenuSlots>(state);

  const { headerProps, footerProps, defaultRender } = state;

  return (
    <state.containerSlot>
      {headerProps && state.headerSlot && (
        <state.headerSlot>
          <MenuItemShim
            key={`header-${headerProps.key || "header"}`}
            itemProps={{ ...headerProps, persistOnClick: true }}
            onDismiss={() => {}}
          />
        </state.headerSlot>
      )}
      {<state.bodySlot>{defaultRender()}</state.bodySlot>}
      {
        <state.footerSlot>
          <MenuItemShim
            key={`footer-${footerProps.key || "footer"}`}
            itemProps={footerProps}
            footerItem={{ isFooterItem: true }}
          />
        </state.footerSlot>
      }
    </state.containerSlot>
  );
};
